import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
import GmailIntegration from '../components/settings/GmailIntegration';
import Preferences from '../components/settings/Preferences';
import AISettings from '../components/settings/AISettings';

export default function Settings() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Settings</h1>
      
      <Tabs defaultValue="email" className="space-y-6">
        <TabsList>
          <TabsTrigger value="email">Email Integration</TabsTrigger>
          <TabsTrigger value="preferences">Preferences</TabsTrigger>
          <TabsTrigger value="ai">Artificial Intelligence</TabsTrigger>
        </TabsList>

        <TabsContent value="email" className="space-y-6">
          <GmailIntegration />
        </TabsContent>

        <TabsContent value="preferences">
          <Preferences />
        </TabsContent>

        <TabsContent value="ai">
          <AISettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}